module.exports = __webpack_public_path__ + "img/vaughn-back-patio.ead7cfd0.jpg";